var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.076 392.227C363.076 392.227 362.099 410.751 326.202 471.174C284.626 541.192 280.721 623.152 323.185 691.574C412.706 835.819 655.666 833.094 745.741 691.663C780.573 636.956 790.557 574.184 778.665 510.415C778.665 510.415 749.846 377.271 651.428 293.316C652.981 294.624 656.797 312.438 657.529 320.038C659.77 343.392 657.574 367.876 649.742 390.1C643.996 406.43 636.031 420.567 622.564 431.468C622.564 427.657 621.61 420.833 621.588 418.55C620.944 372.042 602.929 328.968 573.577 292.807C547.93 261.255 512.765 239.718 475.737 223.875C476.668 227.066 478.399 240.294 478.643 242.908C480.551 264.866 480.906 295.621 478.022 317.557C475.138 339.493 470.19 351.435 463.468 371.998C453.284 403.173 439.418 426.283 421.847 454.002C418.607 459.098 408.934 473.08 403.765 480.148C403.765 480.148 394.868 423.957 363.098 392.227H363.076Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 27.2798L972.779 264.154C986.702 272.193 995.279 287.049 995.279 303.125V776.875C995.279 792.951 986.702 807.807 972.779 815.846L562.5 1052.72C548.577 1060.76 531.423 1060.76 517.5 1052.72L107.221 815.846C93.2982 807.807 84.7213 792.951 84.7213 776.875V303.125C84.7213 287.048 93.2982 272.193 107.221 264.154L517.5 27.2798C531.423 19.2413 548.577 19.2413 562.5 27.2798Z",
    stroke: "white",
    strokeWidth: 24.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitlogo);
export default __webpack_public_path__ + "static/media/litlogo.1eab03fa3441b0b9ffb9c3d1a8b99af6.svg";
export { ForwardRef as ReactComponent };